import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  return (
    <SiteLayout>
      <section className="w-full px-4 md:px-8 lg:px-12 py-24 md:py-32 flex flex-col items-center text-center">
        <span className="font-heading font-black text-6xl md:text-8xl text-background-300 select-none">
          404
        </span>
        <h1 className="mt-6 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
          这个页面没找到
        </h1>
        <p className="mt-3 max-w-md text-sm md:text-base leading-relaxed text-foreground-600">
          可能是链接输了错别字，也可能是这条记录已经被合并或更正了。回到首页或者围观前线，继续看瓜吧。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            回到首页
          </Link>
          <Link
            to="/frontline"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md border border-background-300 text-foreground-800 font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-radar-line"></i>
            去围观前线
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}